import React, { FunctionComponent } from 'react';
import ConfiguratorControlsLayout from '../../../../common/components/layouts/configuratorControlsLayout/ConfiguratorControlsLayout';
import FeatureSectionsContainer from './featureSection/FeatureSectionsContainer';
import { useAvailableSections } from '../../../hooks/useAvailableSections';
import SummarySection from './summary/summarySection/SummarySection';
import { ISpcTheme } from '../../../../common/theme/ISpcTheme';
import { useTheme } from '@material-ui/core';
import VariantsSectionContainer from './variantsSection/VariantsSectionContainer';
import ModelSectionContainer from './modelSelector/modelSectionContainer/ModelSectionContainer';
import InsuranceBlockContainer from './insuranceBlock/InsuranceBlockContainer';
import useSalesEnablementContext from '../../../../gqlCommon/hooks/useSalesEnablementContext';
import usePlatformConfig from '../../../../common/react/usePlatformConfig';
import useCustomizeCarContext from '../../../hooks/useCustomizeCarContext';

const CustomiseControls: FunctionComponent = () => {
  const {
    spc: {
      customise: { displayModelSection, displayVariantsSection },
    },
  } = useTheme<ISpcTheme>();
  const {
    platformConfig: { insuranceIntegration, hideCustomiseModelSectionInSalesEnablement },
  } = usePlatformConfig();

  const { loading, selectedCar } = useCustomizeCarContext();
  const { initializedWithStock, isInSalesEnablement } = useSalesEnablementContext();
  const { sections, featureSections } = useAvailableSections();

  return (
    <ConfiguratorControlsLayout>
      {hideCustomiseModelSectionInSalesEnablement && isInSalesEnablement
        ? !!displayModelSection && !initializedWithStock && <ModelSectionContainer />
        : !!displayModelSection && <ModelSectionContainer />}
      {!!displayVariantsSection && !initializedWithStock && <VariantsSectionContainer />}
      {featureSections.length !== 0 && (
        <FeatureSectionsContainer sections={sections} loading={loading && !selectedCar} />
      )}
      {insuranceIntegration && <InsuranceBlockContainer />}
      <SummarySection />
    </ConfiguratorControlsLayout>
  );
};

export default CustomiseControls;
